// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import PropertiesPlugin from "./PropertiesPlugin";
import { Session, _SessionManager } from "./Context/Session";
import { TelemetryTrace } from "./Context/TelemetryTrace";
import { TelemetryContext } from "./TelemetryContext";
export { PropertiesPlugin, TelemetryTrace, TelemetryContext, Session, _SessionManager as SessionManager };
//# sourceMappingURL=applicationinsights-properties-js.js.map